function adjustSectionMargin(section) {
	const container = document.querySelector('.wcl-container');

	const containerWidthWithPadding = container.offsetWidth;

	const windowWidth = window.innerWidth;

	const paddingValue = windowWidth < 768 ? 50 : 100;

	const containerWidthWithoutPadding = containerWidthWithPadding - paddingValue;

	const marginValue = (windowWidth - containerWidthWithoutPadding) / -2;

	section.style.marginLeft = `${marginValue}px`;
	section.style.marginRight = `${marginValue}px`;
}


const mainBanner = document.querySelector('.wcl-main-banner');

if (mainBanner) {
	window.addEventListener('DOMContentLoaded', adjustSectionMargin(mainBanner));
	window.addEventListener('resize', () => adjustSectionMargin(mainBanner));
}


const quickHelpsAnimation = document.querySelector('.wcl-quick-helps .data-animation #tsparticles');

if (quickHelpsAnimation) {
	window.addEventListener('DOMContentLoaded', adjustSectionMargin(quickHelpsAnimation));
	window.addEventListener('resize', () => adjustSectionMargin(quickHelpsAnimation));
}
